import React from 'react';
import EasyMoveLegalBanner from '../../02_molecules/banner/EasyMoveLegalBanner';
import TaxDeductionBanner from '../../02_molecules/banner/TaxDeductionBanner';
import Carkeyvisual from '../../03_organisms/carkeyvisual/Carkeyvisual';
import Models from '../../03_organisms/models/Models';
import Page from '../../04_layouts/page/Page';
import './home.scss';

export default function Home() {

  return (
    <Page chat footer lightFooter dlLabel="home" name={`home`}>
      <TaxDeductionBanner />
      <Carkeyvisual />
      <Models />
      <EasyMoveLegalBanner />
    </Page>
  );
}
